import { FabricSwatch } from "@/models/products/fabric";

/**
 * Returns the filename stem (no extension) the 3D viewer should use when
 * loading this fabric's texture from Wasabi.
 *
 * Fabrics imported under the 2026 schema have a server-assigned texture_key
 * baked into a deterministic filename like
 * "sunbrella_sunbrella-shade_cloud_14609-0000". Legacy fabrics fall back to
 * mfr_code, which matches the filename already present at /sd/textures/{mfr_code}.jpg.
 *
 * VIEWER-ONLY. Do not use this for SKU generation, ConfigFile serialization,
 * or any API call — those continue to use mfr_code.
 */
export function fabricTextureKey(fabric: FabricSwatch | null | undefined): string {
  if (!fabric) return "";
  return fabric.texture_key || fabric.mfr_code;
}

/**
 * Frankford Signature Fabrics (FUMBDATA-67) — fabrics whose brand collection is
 * "frankford_signature". The fabric selector groups them at the top of the list
 * under a "New for 2027!" callout.
 */
export const SIGNATURE_BRAND_COLLECTION = "frankford_signature";

export function isSignatureFabric(fabric: FabricSwatch | null | undefined): boolean {
  return fabric?.brand?.brand_collection?.handle === SIGNATURE_BRAND_COLLECTION;
}
